import { useContext } from "react";
import { FormPaymentMethods } from "./components";
import { WizardDataFormContext } from "../../Wizard/contexts/WizardDataForm";
import { ConfirmationPreliquidation } from "../../shared/components";


export const StepThree = () => {
    const { canShowConfirmIssue } = useContext(WizardDataFormContext);
  
    return canShowConfirmIssue ? <ConfirmationPreliquidation />: <FormPaymentMethods />
  };

